import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function storiesSlider() {
  const sliders = document.querySelectorAll(".stories-slider");
  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderElement) => {
    const swiperInstance = new Swiper(sliderElement, {
      // modules: [Autoplay, EffectFade, Pagination],
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      autoHeight: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 300,
      keyboard: {
        enabled: true,
      },
      pagination: {
        type: "progressbar",
        el: sliderElement.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });

    // Pause/Play button functionality
    const controlButton = sliderElement.querySelector(".swiper-control");
    controlButton.addEventListener("click", () => {
      if (swiperInstance.autoplay.running) {
        swiperInstance.autoplay.stop();
        controlButton.classList.add("paused");
      } else {
        swiperInstance.autoplay.start();
        controlButton.classList.remove("paused");
      }
    });
  });
}

export { storiesSlider };
